import { REQUEST_CHANGE } from '../../actions';

const requestReducer = (oldState = {
  requestVm: {
    selectedDayOfWeek: new Set(),
    message: '',
    pets2Pate: new Set(),
    cleanIncluded: new Set(),
    requestPlace: '',
    from: '',
    to: ''
  }
}, action) => {
  const { requestVm } = oldState;
  switch (action.type) {
    case REQUEST_CHANGE:
    {
      const { name, value } = action;
      if ((requestVm[name]) instanceof Set) {
        if (requestVm[name].has(value)) {
          requestVm[name].delete(value);
        } else {
          requestVm[name].add(value);
        }

        return { ...oldState, requestVm: { ...requestVm, [name]: new Set(requestVm[name]) } };
      }

      return { ...oldState, requestVm: { ...requestVm, [name]: value } };
    }
    default:
      return oldState;
  }
};

export default requestReducer;



// WEBPACK FOOTER //
// ./src/pages/Request/requestReducer.js